
import {Component, Vue} from 'vue-property-decorator';
import ClienteViewComponent from "@/components/ClienteViewComponent.vue"

@Component({
  name: "ClienteNew",
  components: {
    ClienteViewComponent
  }
})
export default class ClienteNew extends Vue {
}
